import { render, staticRenderFns } from "./ReportListAndCard.vue?vue&type=template&id=4930d520"
import script from "./ReportListAndCard.vue?vue&type=script&lang=js"
export * from "./ReportListAndCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports